import composeRuntimeEvents from './Runtime/composeRuntimeEvents';
import composeRuntimePeer from './Runtime/composeRuntimePeer';

/**
 * Append runtime params to funnelback query (these are not displaye in the browser URL)
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {string} moduleType
 * @param {Object} filters
 * @returns {Object}
 */

const composeRuntimeParams = ({ moduleType, filters = {} }) => {
  // exclude config
  let params = {
    meta_id_not: 'config',
  };

  switch (moduleType) {
    case 'event':
      return { ...params, ...composeRuntimeEvents(filters) };
    case 'peer-support':
      return { ...params, ...composeRuntimePeer(filters) };
  }

  return params;
};

export default composeRuntimeParams;
